import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.518 12c0-.368.298-.667.666-.667h.007a.667.667 0 1 1 0 1.334h-.007A.667.667 0 0 1 7.518 12M6.684 3a.5.5 0 1 0 0 1h3a.5.5 0 0 0 0-1z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.851 2.667a2 2 0 0 1 2-2h8.667a2 2 0 0 1 2 2v10.666a2 2 0 0 1-2 2H3.85a2 2 0 0 1-2-2zm2-.667a.667.667 0 0 0-.667.667v10.666c0 .369.299.667.667.667h8.667a.667.667 0 0 0 .666-.667V2.667A.667.667 0 0 0 12.518 2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })